import { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import { SiteHeader } from './components/SiteHeader'
import { HomePage } from './pages/HomePage'

const DayPage = lazy(() => import('./pages/DayPage'))
const WalletPage = lazy(() => import('./pages/WalletPage'))

function ScrollManager() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])
  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <SiteHeader />
      <Suspense fallback={<div className="route-loading" aria-live="polite">Opening the journal…</div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/day/:slug" element={<DayPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
